import React, {Component} from 'react';
import MetaTags from 'react-meta-tags';
export default class Disclaimer extends Component {
  componentDidMount() {
    window.scrollTo(0,0)
  }
  render() {
    return(
      <div className="container-fluid">
       <div className="row haspcMinH" style={Jeyu.banner}>
       <MetaTags>
            <title>草學藥事 || 免責聲明</title>
            <meta id="og-title" property="og:title" content="免責聲明" />
        </MetaTags>
        <div className="container">
         <div className="row">
          <div style={Jeyu.comingSoon} className="mobileInfo" >
           <h1>草學藥事 免責聲明</h1>
           <p>
            歡迎您光臨「草學藥事」(以下簡稱本平台)，任何瀏覽平台的人士，須自行承擔一切風險，本平台不會負責任何因瀏覽或使用本平台而引致之損失。<br />
            本平台不會作出任何默示的擔保。
           </p>
           <p>本平台可隨時停止或變更網頁資料及有關條款而毋須事前通知用戶。 </p>
           <p>本平台承諾力求平台內容之準確性及完整性，但內容如有錯誤或遺漏，本平台不會承擔任何賠償責任，所有本平台內容，將會隨時更改，而不作另行通知。 </p>
           <p>引用或刊登本平台(內容、圖片)須先與本平台聯絡、取得合法授權。 若經查證無取得授權、本平台會尋求究責損失賠償。</p>
           <p>本平台會對使用或連結本網頁而引致任何損害(包括但不限於電腦病毒、系統固障、資料損失)、誹謗、侵犯版權或知識產權所造成的損失，<br />包括但不限於利潤、商譽、使用、資料損失或其他無形損失，本平台不承擔任何直接、間接、附帶、特別、衍生性或懲罰性賠償。</p>
           <p>本公司可能會連接至其他機構所提供的網頁，本公司不會對這些網頁內容作出任何保證或承擔任何責任。使用者如瀏覽這些網頁，將要自己承擔後果。是否使用本平台之服務下載或取得任何資料應由用戶自行考慮且自負風險，因前開任何資料之下載而導致用戶電腦系統之任何損壞或資料流失，本平台不承擔任何責任。</p>
          </div>
         </div>
        </div>
       </div>
      </div>
    )
  }
}

const Jeyu = {
  banner: {
    background: '#eeede9',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '130px 20px'
  },
  comingSoon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'left'
  }
}



// WEBPACK FOOTER //
// ./src/View/Disclaimer.js